import apiClient from './client';

export const clientReportsAPI = {
  // Get all reports for a campaign
  getCampaignReports: (campaignId) =>
    apiClient.get(`/client-reports/campaign/${campaignId}`),

  // Get single report
  getReport: (reportId) =>
    apiClient.get(`/client-reports/${reportId}`),

  // Create new report
  createReport: (data) =>
    apiClient.post('/client-reports', data),

  // Update report
  updateReport: (reportId, data) =>
    apiClient.put(`/client-reports/${reportId}`, data),

  // Delete report
  deleteReport: (reportId) =>
    apiClient.delete(`/client-reports/${reportId}`),

  // Toggle sent status
  toggleSent: (reportId) =>
    apiClient.post(`/client-reports/${reportId}/toggle-sent`),

  // Get full report data for PDF generation.
  // Override the shared 10s timeout — a large multi-month report (thousands of
  // content items) genuinely takes longer than 10s to aggregate.
  getFullReportData: (reportId) =>
    apiClient.get(`/client-reports/${reportId}/full-data`, { timeout: 120000 }),

  // Refresh report data with new date range.
  // Same reason as above: big reports exceed the default 10s timeout.
  refreshReportData: (reportId, reportPeriodStart, reportPeriodEnd) =>
    apiClient.post(`/client-reports/${reportId}/refresh-data`, {
      reportPeriodStart,
      reportPeriodEnd
    }, { timeout: 120000 }),
};

// Report Images API
export const reportImagesAPI = {
  // Upload image (base64)
  upload: (data) =>
    apiClient.post('/report-images/upload', data),

  // Get image by ID
  getImage: (id) =>
    apiClient.get(`/report-images/${id}`),

  // Get image file URL (for img src)
  getImageUrl: (id) =>
    `${apiClient.defaults.baseURL}/report-images/${id}/file`,

  // List recent images
  listRecent: (limit = 20) =>
    apiClient.get('/report-images', { params: { limit } }),

  // Delete image
  deleteImage: (id) =>
    apiClient.delete(`/report-images/${id}`),
};

export default clientReportsAPI;
